import { Component } from '@angular/core';
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';

@Component({
	selector: 'fn-grid-phonenumber',
	templateUrl: 'fn-grid-phone-number.component.html',
	styleUrls: ['fn-grid-phone-number.component.scss'],
})
export class FnGridPhoneNumberComponent extends FnGridAbstractCell {}
